import FancyText from "@carefully-coded/react-text-gradient";
import {
  Alert,
  AlertTitle,
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import SuggestionChips from "./suggestions";
import { motion } from "framer-motion";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";

export default function NewChatGreetings({
  suggestions,
  tool,
}: {
  suggestions: string[];
  tool: string;
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      height={"100%"}
      display="flex"
      flexDirection="column"
      justifyContent={"center"}
      alignItems="center"
      p={1}
      px={2}
    >
      <Grid container justifyContent={"center"} alignItems={"center"}>
        <Grid item md={8}>
          <Box>
            <Box>
              <motion.div
                initial={{ y: 100 }}
                transition={{ duration: 0.5 }}
                whileInView={{ y: 0 }}
                style={{ zIndex: -1 }}
              >
                <Typography
                  variant={isSmallScreen ? "h3" : "h2"}
                  fontWeight={"600"}
                >
                  {/* <LinearGradient gradient={["to left", "#fbd07c ,#f7f779"]}> */}
                  <FancyText
                    gradient={{
                      from: "#1a73c6",
                      to: "#04A05F",
                      type: "linear",
                    }}
                    animate
                    animateDuration={1500}
                  >
                    {tool}
                  </FancyText>
                  {/* </LinearGradient> */}
                </Typography>
              </motion.div>
              <motion.div
                initial={{ y: 100 }}
                transition={{ duration: 0.75 }}
                whileInView={{ y: 0 }}
                style={{ zIndex: -1 }}
              >
                <Typography
                  variant={isSmallScreen ? "h4" : "h4"}
                  fontWeight={"600"}
                  mt={4}
                  sx={{}}
                >
                  {/* <LinearGradient gradient={["to left", "#fec32f ,#fec32f"]}> */}
                  Hello.
                  {/* </LinearGradient> */}
                </Typography>
              </motion.div>
              <motion.div
                initial={{ y: 100 }}
                transition={{ duration: 1 }}
                whileInView={{ y: 0 }}
                style={{ zIndex: -1 }}
              >
                <Typography
                  variant={isSmallScreen ? "h5" : "h5"}
                  color={grey[500]}
                >
                  How can I help you today?
                </Typography>
              </motion.div>
            </Box>
            <Box mt={isSmallScreen ? 2 : 4}>
              <SuggestionChips suggestions={suggestions} gridSpace={3} />
            </Box>
            <Box my={1}>
              <motion.div
                initial={{ y: 100 }}
                transition={{ duration: 1.25 }}
                whileInView={{ y: 0 }}
                style={{ zIndex: -1 }}
              >
                <Alert severity="warning" sx={{ fontSize: "0.75rem" }}>
                  <AlertTitle sx={{ fontSize: "0.8rem" }}>
                    Disclaimer
                  </AlertTitle>
                  Alembic shall not be responsible and liable for any action,
                  loss, damages and claims caused based on any material or
                  information generated by AI.
                </Alert>
              </motion.div>
            </Box>
            <Box my={1}>
              <motion.div
                initial={{ y: 100 }}
                transition={{ duration: 1.25 }}
                whileInView={{ y: 0 }}
                style={{ zIndex: -1 }}
              >
                <Alert severity="info" sx={{ fontSize: "0.75rem" }}>
                  Note: Bot currently answers only Mediclaim and EDGE Promotion queries, more things will be coming soon.
                </Alert>
              </motion.div>
            </Box>
            <Box my={1}>
              <motion.div
                initial={{ y: 100 }}
                transition={{ duration: 1.25 }}
                whileInView={{ y: 0 }}
                style={{ zIndex: -1 }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.75rem",
                    backgroundColor: "transparent",
                    color: "inherit",
                    boxShadow: "none",
                    border: "none",
                    fontWeight: 600,
                    padding: " 0 18px",
                  }}
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "1.2rem", 
                      height: "1.2rem",
                      borderRadius: "50%",
                      backgroundColor: "white", 
                      // border: "2px solid #1d95d6",
                      marginRight: "12px", 
                    }}
                  >
                    <EventNoteOutlinedIcon
                      sx={{
                        fontSize: "1rem",
                        color: "#1d95d6",
                      }}
                    />
                  </Box>{" "}
                  <Typography sx={{ fontSize: "0.75rem", fontWeight: 600 }}>
                    User Guidelines:{" "}
                    <a
                      target="blank"
                      href="https://drive.google.com/drive/folders/1yQf9j4LkbhlZzs2n-rs1tzfnnv-AW18b?usp=sharing"
                      style={{ textDecoration: "underline", color: "#1d95d6" }}
                    >
                      Click here
                    </a>
                  </Typography>
                </Box>
              </motion.div>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
